import XDate from 'xdate';
import {SET_EVITE_EVENT} from '~/CreateFabricGreetingCard/reducers/eviteEvent/constants';
import {
  selectHostIds,
  selectPendingHostIds,
} from '~/CreateFabricGreetingCard/reducers/eviteEvent/selectors';
import {
  selectSelectedBackground,
  selectSelectedEnvelope,
  selectSelectedLiner,
  selectSelectedStamp,
} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {selectGlobalMessage} from '~/CreateFabricGreetingCard/reducers/recipientsMessage';
import {updateEventIdInPathname} from '~/CreateFabricGreetingCard/utils/save';
import {selectUserOrSystemDisabled} from '~/common/fabric/GiftCard/reducers/eGiftCard';
import {formatTimezoneOffset} from '~/common/utils';
import {fetchInvitationSummary} from '~/ViewInvitation/reducers/apiActions';
import {toastAlert} from '~library/atoms/Toast';
import {AlertLineIcon} from '~library/svg/AlertLineIcon';

// TODO: we are commenting this out for a temporary hot fix (EVT-27156). Uncomment when EVT-27159 is fixed
// import {selectEventToBackendSnapshot} from '~/common/fabric/Snapshot/reducers/selector';
// import isEqual from 'lodash/isEqual';
// import {setEventToBackendSnapshot} from '~/common/fabric/Snapshot/reducers';

const now = () => {
  const future = new XDate();
  return future.toString('i').slice(0, 16) + formatTimezoneOffset();
};

const getTimezoneId = (name) => {
  try {
    return window.TIMEZONES.find((t) => t.timezone_display_name === name).timezone_id;
    // biome-ignore lint/correctness/noUnusedVariables: existing error
  } catch (e) {
    return name;
  }
};

export const stateToBackendEventRepresentation = (state) => {
  const {details, fabricTemplate, eviteEvent, fabricDesign, review, eGiftCard} = state;
  const background = selectSelectedBackground(state);
  const stamp = selectSelectedStamp(state);
  const liner = selectSelectedLiner(state);
  const envelope = selectSelectedEnvelope(state);
  const globalMessage = selectGlobalMessage(state);
  const egiftCardDisabled = selectUserOrSystemDisabled(state);

  const hostIds = selectHostIds(state);
  const pendingHostIds = selectPendingHostIds(state);
  // biome-ignore lint/correctness/noUnusedVariables: existing error
  const {guessing_games_data, sent_on, last_updated, date_created, rsvp, ...eventData} = eviteEvent;

  const sendLaterTimezone = evite.features.isEnabled('greeting_card_send_later_timezone', false);
  let amountInCents = 0;
  if (eGiftCard?.productConfigId && !eGiftCard.userDisabled) {
    amountInCents = eGiftCard.value;
  }
  const giftCardData = {
    // biome-ignore lint/style/useNamingConvention: existing error
    amount_in_cents: amountInCents,
    // biome-ignore lint/style/useNamingConvention: existing error
    product_config_id: eGiftCard?.productConfigId || '',
    // biome-ignore lint/style/useNamingConvention: existing error
    product_config_name: eGiftCard?.productConfigName || '',
    image: eGiftCard?.image || '',
    // biome-ignore lint/style/useNamingConvention: existing error
    user_disabled: !!eGiftCard?.userDisabled,
  };
  const event = {
    ...eventData,
    // biome-ignore lint/style/useNamingConvention: existing error
    host_ids: hostIds,
    // biome-ignore lint/style/useNamingConvention: existing error
    pending_host_ids: pendingHostIds,
    origin: 22,
    status: eviteEvent.status || 'draft',
    // biome-ignore lint/style/useNamingConvention: existing error
    template_name: fabricTemplate.templateName,
    // biome-ignore lint/style/useNamingConvention: existing error
    fabric_design_data: fabricDesign.fabricArt,
    // biome-ignore lint/style/useNamingConvention: existing error
    card_back_text_content: globalMessage,
    // biome-ignore lint/style/useNamingConvention: existing error
    phone_number: '',
    // biome-ignore lint/style/useNamingConvention: existing error
    event_type: details.type,
    // biome-ignore lint/style/useNamingConvention: existing error
    used_as: egiftCardDisabled ? 'card' : 'gift_card',
    // biome-ignore lint/style/useNamingConvention: existing error
    gift_card_data: giftCardData,
    // biome-ignore lint/style/useNamingConvention: existing error
    user_saved: true,
    // biome-ignore lint/style/useNamingConvention: existing error
    cohost_name1: details.cohost.name,
    // biome-ignore lint/style/useNamingConvention: existing error
    cohost_email1: details.cohost.email,
    // biome-ignore lint/style/useNamingConvention: existing error
    location_name: details.location,
    // biome-ignore lint/style/useNamingConvention: existing error
    street_address: details.address.street,
    city: details.address.city,
    state: details.address.state,
    // biome-ignore lint/style/useNamingConvention: existing error
    zip_code: details.address.zip,
    title: details.title,
    message: details.notes,
    // biome-ignore lint/style/useNamingConvention: existing error
    start_datetime: details.start
      ? XDate(details.start).toString('i').slice(0, 16) + formatTimezoneOffset()
      : now(),
    // biome-ignore lint/style/useNamingConvention: existing error
    host_name: review.eventHostName || details.host,
    // biome-ignore lint/style/useNamingConvention: existing error
    event_host_name: review.eventHostName || details.host,
    // biome-ignore lint/style/useNamingConvention: existing error
    end_datetime:
      details.end && XDate(details.end).toString('i').slice(0, 16) + formatTimezoneOffset(),
    // biome-ignore lint/style/useNamingConvention: existing error
    stop_datetime:
      details.stop && XDate(details.stop).toString('i').slice(0, 16) + +formatTimezoneOffset(),
    // biome-ignore lint/style/useNamingConvention: existing error
    known_timezone_name:
      review.deliverCardNow || !sendLaterTimezone
        ? null
        : getTimezoneId(review.known_timezone_name),
    // biome-ignore lint/style/useNamingConvention: existing error
    known_timezone_abbr:
      review.deliverCardNow || !sendLaterTimezone ? null : review.known_timezone_abbr,
    // biome-ignore lint/style/useNamingConvention: existing error
    send_on: review.deliverCardNow
      ? null
      : XDate(review.deliveryCardDateTime).toString('i').slice(0, 16),
    // biome-ignore lint/style/useNamingConvention: existing error
    gift_keywords: null,
    // biome-ignore lint/style/useNamingConvention: existing error
    gift_list_url: null,
    wishlist: null,
    options: {
      ...eviteEvent.options,
      // biome-ignore lint/style/useNamingConvention: existing error
      event_option_allow_invite_more: false, // This will no longer be supported in Fabric invitations
      // Remove rendered data so we don't overwrite what is on the server getting set asynchronously
      // biome-ignore lint/style/useNamingConvention: existing error
      rendered_image_filename: undefined,
      // biome-ignore lint/style/useNamingConvention: existing error
      rendered_image_gs_key: undefined,
      // biome-ignore lint/style/useNamingConvention: existing error
      rendered_image_url: undefined,
      // biome-ignore lint/style/useNamingConvention: existing error
      rendered_text_image_url: undefined,
      // biome-ignore lint/style/useNamingConvention: existing error
      write: {text_layer_back: globalMessage},
    },
    // biome-ignore lint/style/useNamingConvention: existing error
    is_fabric_premium: details.isPremium,
    // biome-ignore lint/style/useNamingConvention: existing error
    pledgeling_new_api: true,
    // fields to not send back
    // biome-ignore lint/style/useNamingConvention: existing error
    guessing_games_data: undefined,
    // biome-ignore lint/style/useNamingConvention: existing error
    sent_on: undefined,
    // biome-ignore lint/style/useNamingConvention: existing error
    last_updated: undefined,
    // biome-ignore lint/style/useNamingConvention: existing error
    date_created: undefined,
    rsvp: undefined,
  };
  event.options.design = event.options.design || {};
  const {design} = event.options;
  if (envelope) {
    design.envelope = envelope.id;
    design.envelope_flap_down = envelope.flap_down_image;
    design.envelope_flap_up = envelope.blank;
    design.envelope_front = envelope.image;
    design.name_style = {
      // Text style for names on front of envelopes
      align: 'center',
      color: envelope.text_color,
      font: 'Financier',
      position: {x: 15, x2: 605, y: 225, y2: 465},
      size: 48,
    };

    if (liner) {
      design.liner = liner.id;
      for (const media of liner.media) if (media.label === 'image') design.liner_image = media.url;
    }
    if (stamp) {
      design.stamp = stamp.id;
      for (const media of stamp.media) if (media.label === 'image') design.stamp_image = media.url;
    }
    if (fabricDesign.backgroundId) {
      design.background = fabricDesign.backgroundId;
      for (const media of background.media)
        if (media.label === 'mobile') design.background_image_mobile = media.url;
      for (const media of background.media)
        if (media.label === 'desktop') design.background_image_desktop = media.url;
      design.background_color = null;
    } else {
      design.background = null;
      design.background_image_mobile = null;
      design.background_image_desktop = null;
      design.background_color = fabricDesign.backgroundColor;
    }
  }
  design.envelope_fabric_stickers = fabricDesign.envelopeStickers;
  if (!event.tracking_data)
    // biome-ignore lint/style/useNamingConvention: existing error
    event.tracking_data = {gallery_category: details.tracking_gallery_category};

  window.saveUTMToObj(event);

  return event;
};

export const saveEventThunk =
  (saveToBackend = true, delayFetchSummary = 0) =>
  async (dispatch, getState) => {
    const state = getState();
    const eventId = state.eviteEvent.id;
    const {origin} = window.location;
    const url = eventId
      ? new URL(`/ajax/greeting-card/${eventId}/update`, origin)
      : new URL('/ajax/greeting-card/create', origin);

    const eventRepresentation = stateToBackendEventRepresentation(state);
    // TODO: we are commenting this out for a temporary hot fix (EVT-27156). Uncomment when EVT-27159 is fixed
    // const eventRepresentationSnapshot = selectEventToBackendSnapshot(getState());
    // const eventStateHasChanges = !eventRepresentationSnapshot
    //   ? true
    //   : !isEqual(eventRepresentation, eventRepresentationSnapshot);

    // if (saveToBackend && eventStateHasChanges) {
    if (saveToBackend) {
      let resp;
      try {
        resp = await evite.fetch(url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'X-CSRFToken': evite.cookie('csrftoken'),
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(eventRepresentation),
        });
        // biome-ignore lint/correctness/noUnusedVariables: existing error
      } catch (e) {
        toastAlert('Failed to save card, please try again', {
          icon: <AlertLineIcon />,
          type: 'error',
          position: 'top-right',
        });
      }
      if (!resp.ok) {
        const {message} = await resp.json();
        evite.error('Failed to save eCard', new Error(message));
        toastAlert(message || 'Card could not be saved. Please try again or contact support.', {
          icon: <AlertLineIcon />,
          type: 'error',
          position: 'top-right',
        });
        // biome-ignore lint/style/useThrowOnlyError: existing error
        throw 'Save failed';
      }
      const results = await resp.json();
      if (!eventId) updateEventIdInPathname(results.event.id);
      window.evite_event = results.event;
      dispatch({type: SET_EVITE_EVENT, payload: results.event});
      // TODO: we are commenting this out for a temporary hot fix (EVT-27156). Uncomment when EVT-27159 is fixed
      // dispatch(
      //   setEventToBackendSnapshot(stateToBackendEventRepresentation(getState(), sendInvitations))
      // );
    } else {
      window.evite_event = eventRepresentation;
      dispatch({type: SET_EVITE_EVENT, payload: eventRepresentation});
      // TODO: we are commenting this out for a temporary hot fix (EVT-27156). Uncomment when EVT-27159 is fixed
      // dispatch(
      //     setEventToBackendSnapshot(stateToBackendEventRepresentation(getState(), sendInvitations))
      // );
    }

    if (window.evite_event) {
      if (delayFetchSummary > 0) {
        setTimeout(async () => {
          await dispatch(fetchInvitationSummary(window.evite_event.id));
        }, delayFetchSummary);
      } else {
        await dispatch(fetchInvitationSummary(window.evite_event.id));
      }
    }
  };
